import { EditGridColumnType } from '../../../../../components/FinalMolGrid/libs/data/editGridColumnType';
import { GridColumnType } from '../../../../../components/FinalMolGrid/libs/data/gridColumnType';

export const editableMolGridConfig = {
    columns: [
        {
            name: "Name",
            fieldName: "name",
            allowShort: false,
            colStyle: {
                width: "22%",
                textAlign: "center",
            },
        },
        {
            name: "Working-Days",
            fieldName: "workingDays",
            allowShort: false,
            allowEditColumn: true,
            colStyle: {
                width: "13%",
                textAlign: "center",
            },
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Please Enter Working Days",
                editColFieldName: "workingDays",
                isDisable: false,
                colConfig: {
                    maxLength: 2,
                    isReadOnly: false,
                },
                editColValidation: [
                    { type: "required", message: "Working Days is required." },
                ],
            }
        },
        {
            name: "Working Hrs",
            fieldName: "workingHours",
            allowShort: false,
            colStyle: {
                width: "13%",
                textAlign: "center",
            },
            // allowEditColumn: true,
            // editColumn: {
            //     editColType: EditGridColumnType.NUMERIC,
            //     placeholder: "Please Enter Working Hours",
            //     editColFieldName: "workingHours",
            //     isDisable: false,
            //     colConfig: {
            //         maxLength: 3,
            //         isReadOnly: false,
            //     },
            //     editColValidation: [
            //         { type: "required", message: "Working Hour is required." },
            //     ],
            // }

        },

        {
            name: "Productive %",
            // fieldName: "productivePercentage",
            fieldName: "productive",
            allowShort: false,
            allowEditColumn: true,
            colStyle: {
                width: "13%",
                textAlign: "center",
            } ,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "Please Enter Productive %",
                editColFieldName: "productive",
                isDisable: false,
                colConfig: {
                    maxLength: 3,
                    isReadOnly: false,
                },
                editColValidation: [
                    { type: "required", message: "Productive % is required." },
                ],
            }
          
        },
        {
            name: "Prod. Hrs",
            fieldName: "productive_Hr",
            allowShort: false,
            colStyle: {
                width: "13%",
                textAlign: "center",
            },

        },
        {
            name: "Est. Hrs",
            fieldName: "esitmated_Hr",
            allowShort: false,
            colStyle: {
                width: "13%",
                textAlign: "center",
            },
            // allowEditColumn: true,
            // editColumn: {
            //     editColType: EditGridColumnType.NUMERIC,
            //     placeholder: "Please Enter Est. Hrs",
            //     editColFieldName: "esitmated_Hr",
            //     isDisable: false,
            //     colConfig: {
            //         maxLength: 5,
            //         isReadOnly: false,
            //     },
            //     editColValidation: [
            //         { type: "required", message: "Est. Hrs is required." },
            //     ],
            // }

        },
        {
            name: "In-Direct Hrs",
            fieldName: "inDirect_Hr",
            allowShort: false,
            colStyle: {
                width: "13%",
                textAlign: "center",
            },

        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete:true
            },
            colStyle: {
                width: "150px",
                textAlign: "center",
            },
            allowShort: false
        },

    ],
    editSettings: {
        buttons: {
            save: true,
            cancel: true
        }
    },
    allowEdit: true,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
}